// extracted by mini-css-extract-plugin
module.exports = {"add-group-component":"AddGroupComponent-module__add-group-component__2sdAa","center-row":"AddGroupComponent-module__center-row__1ouJb"};